import { Question, SourceTable, QuestionType } from '../types';
import { ApiQuestion } from '../api/gameApi';
import { GUARDIAN_IMAGES } from '../constants';

// ---------------------------------------------------------------------------
// Guardian name derived from SDG number.
// Guardian of People    — SDG 1–5
// Guardian of Planet    — SDG 6, 12–15
// Guardian of Prosperity — SDG 7–11
// Guardian of Peace     — SDG 16
// Guardian of Partnership — SDG 17
// ---------------------------------------------------------------------------

const SDG_TO_GUARDIAN: Record<number, string> = {
  1: 'Guardian of People',
  2: 'Guardian of People',
  3: 'Guardian of People',
  4: 'Guardian of People',
  5: 'Guardian of People',
  6: 'Guardian of Planet',
  7: 'Guardian of Prosperity',
  8: 'Guardian of Prosperity',
  9: 'Guardian of Prosperity',
  10: 'Guardian of Prosperity',
  11: 'Guardian of Prosperity',
  12: 'Guardian of Planet',
  13: 'Guardian of Planet',
  14: 'Guardian of Planet',
  15: 'Guardian of Planet',
  16: 'Guardian of Peace',
  17: 'Guardian of Partnership',
};

// ---------------------------------------------------------------------------
// The backend stores keywords as 'keyword_resources'; the frontend type uses
// 'keyword_db'. Everything else matches.
// ---------------------------------------------------------------------------

function toSourceTable(raw: string): SourceTable {
  if (raw === 'keyword_resources') return 'keyword_db';
  return raw as SourceTable;
}

// ---------------------------------------------------------------------------
// Public mapper
// ---------------------------------------------------------------------------

/**
 * Maps a single backend ApiQuestion into the frontend Question shape.
 * stabilityImpact is fixed: +1 for the correct option, -1 for all others.
 * This satisfies the AC: correct increases score and wrong decreases score
 */
export function mapApiQuestion(q: ApiQuestion): Question {
  const guardianName = q.sdg_numbers?.[0] ? (SDG_TO_GUARDIAN[q.sdg_numbers[0]] ?? 'Guardian') : 'Guardian';
  return {
    questionId:   String(q.question_bank_id),
    sourceTable:  toSourceTable(q.source_table),
    sourceId:     String(q.source_id),
    questionType: q.question_type as QuestionType,
    characterName: guardianName,
    characterImage: GUARDIAN_IMAGES[guardianName],
    dialogueText: q.question_text,
    sdgNumbers:   q.sdg_numbers ?? [],
    options: q.options.map((o, index) => ({
      id:              o.id,
      text:            o.text,
      isCorrect:       o.is_correct,
      stabilityImpact: o.is_correct ? 10 : -10,
      // Store the option's position so submitAnswer knows which index to send
      optionIndex:     index,
    })),
  };
}

export function mapApiQuestions(questions: ApiQuestion[]): Question[] {
  return questions.map(mapApiQuestion);
}
